import React from 'react'
import styles from './EmptyDashboard.scss'
import { dashboardMessages } from '../intlMessages'
import { HeroCard } from 'common/styleguide/HeroCard'
import { contentLabel } from 'lib/styleguide/base.scss'
import { Msg } from 'lib/localization'
import { FormattedMessage as T } from 'react-intl'

import findBg from '../img/find_bg.jpg'
import findBg2x from '../img/find_bg@2x.jpg'

import planBg from '../img/plan_bg.jpg'
import planBg2x from '../img/plan_bg@2x.jpg'

import recordBg from '../img/record_bg.jpg'
import recordBg2x from '../img/record_bg@2x.jpg'

export class EmptyDashboard extends React.PureComponent {
  render () {
    return (
      <div className={styles.EmptyDashboard}>
        <div className={styles.constrainWidth}>
          <h1 className={contentLabel}>
            <T id='EmptyDashboard.welcomeH1' defaultMessage='Welcome to Ride with GPS' />
          </h1>
          <h2>
            <T id='EmptyDashboard.welcomeH2'
              defaultMessage='You are about to discover the best tools available to help you plan,
              navigate, and share your routes and rides. Let’s get rolling!' />
          </h2>
        </div>
        <div className={styles.cards}>
          <HeroCard href='/find' focalPoint='center 90%' img={findBg} img2x={findBg2x} scrimOpacity={[0.4, 0.4]} title={<Msg m={dashboardMessages.findRoutes} />}>
            <T id='EmptyDashboard.discoverRoutes'
              defaultMessage='Discover routes in your area or halfway around the world. Quickly and easily send routes to your phone or GPS device to start navigating.' />
          </HeroCard>
          <HeroCard href='/routes/new' img={planBg} img2x={planBg2x} scrimOpacity={[0.4, 0.4]} title={<Msg m={dashboardMessages.planARoute} />}>
            <T id='EmptyDashboard.useTheRoutePlanner'
              defaultMessage='Use the route planner to create completely custom routes and cuesheets. Just click on the map to plot your route, and the planner will take care of the cuesheet automatically.' />
          </HeroCard>
          <HeroCard href='/app' img={recordBg} img2x={recordBg2x} scrimOpacity={[0.4, 0.4]} title={<Msg m={dashboardMessages.recordAndNavigate} />}>
            <T id='EmptyDashboard.installTheApp'
              defaultMessage='Install the Ride with GPS mobile app to navigate and record your rides to your Ride with GPS profile.' />
          </HeroCard>
        </div>
        <div className={styles.constrainWidth}>
          <h1 className={contentLabel}>
            <T id='EmptyDashboard.needHelp' defaultMessage='Need Help?' />
          </h1>
          <p className={styles.help}>
            <T id='EmptyDashboard.contact'
              defaultMessage='Submit a ticket through {link}, or simply email us at {email}. We have staffed support 7 days a week.'
              values={{
                link: <a href='https://ridewithgps.zendesk.com/hc/en-us/requests/new' target='_blank'>
                  <T id='EmptyDashboard.ourHelp' defaultMessage='our help system' />
                </a>,
                email: <a href='mailto:info@ridewithgps.com'>info@ridewithgps.com</a>
              }} />
          </p>
        </div>
      </div>
    )
  }
}
